// src/api.js
import axios from 'axios';

export const uploadDocument = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(`/api/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to upload document');
  }
};

export const uploadMultipleDocuments = async (files) => {
  const formData = new FormData();

  // Append each file with the same field name, e.g. 'files'
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  try {
    const response = await axios.post(`/api/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // The server might return an array of metadata for each file
    // e.g. [ { fileName: 'doc1.pdf', summary: '...' }, { fileName: 'doc2.pdf', ... }, ... ]
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to upload multiple documents');
  }
};

export const deleteDocument = async (fileName) => {
  try {
    const response = await axios.delete(`/api/delete`, {
      data: { fileName }, // <-- Send fileName in request body
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to delete document');
  }
};

export const saveSummaryDocument = async (fileNames, category, isVision) => {
  const response = await axios.post('/api/summarize-docx', {
    fileNames,
    category,
    is_vision: isVision
  });
  return response.data; // { docFileName: string }
};

export const downloadSummaryFile = async (docFileName) => {
  const response = await axios.get(
    `/api/download-summary/${encodeURIComponent(docFileName)}`,
    { responseType: 'blob' }
  );
  return response.data;
};

export const resetAll = async () => {
  await axios.delete('/api/reset');
};

